import { ActionType } from "../types";
import { Applications, ApplicationsAction } from "../types/applications";

export const applications = (
  state: Applications = null,
  action: ApplicationsAction
): Applications => {
  switch (action.type) {
    case ActionType.GET_APPLICATIONS_REQUEST:
      return null;
    case ActionType.GET_APPLICATIONS_SUCCESS:
      return action.applications;
    case ActionType.GET_APPLICATIONS_FAILURE:
      return null;
    default:
      return state;
  }
};
